export const buildCreateOrderApiConfig = (params = {}) => ({
    url: '/api/billing/companies/orders',
    method: 'POST',
    data: params,
});

export const buildEditOrderApiConfig = ({
    id,
    paymentIntentId,
    composition,
}) => ({
    method: 'PUT',
    url: `/api/billing/companies/orders/${id}`,
    data: {
        paymentIntentId,
        composition,
    },
});

export const buildSubmitOrderApiConfig = ({
    id,
    paymentIntentId,
    paymentMethodId,
    recurrencePaymentMethod,
}) => ({
    url: `/api/billing/companies/orders/${id}/payments`,
    method: 'POST',
    data: {
        paymentMethodId,
        paymentIntentId,
        recurrencePaymentMethod,
    },
});
